import { render } from "./TheTicketPurchaseDetailsOfRefund.vue?vue&type=template&id=90cdc298"
import script from "./TheTicketPurchaseDetailsOfRefund.vue?vue&type=script&lang=js"
export * from "./TheTicketPurchaseDetailsOfRefund.vue?vue&type=script&lang=js"
script.render = render

export default script